import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { QrCode, X } from "@phosphor-icons/react";

export default function QRScanner({ onResult, onClose }) {
  const [error, setError] = useState("");
  const scannerRef = useRef(null);
  const regionId = "qr-reader-region";

  useEffect(() => {
    let mounted = true;
    const scanner = new Html5Qrcode(regionId, { verbose: false });
    scannerRef.current = scanner;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        (decodedText) => {
          if (!mounted) return;
          onResult(decodedText);
        },
        () => {}
      )
      .catch((e) => setError(e?.message || "Unable to access camera"));

    return () => {
      mounted = false;
      try {
        if (scanner && scanner.getState && scanner.getState() === 2) {
          scanner.stop().then(() => scanner.clear()).catch(() => {});
        } else {
          scanner.clear();
        }
      } catch (e) {
        /* ignore */
      }
    };
  }, [onResult]);

  return (
    <div className="fixed inset-0 z-50 bg-[#0A0B0E]/90 grid place-items-center p-4" data-testid="qr-scanner-modal">
      <div className="w-full max-w-md border border-[#272A35] bg-[#111318]">
        <div className="flex items-center justify-between border-b border-[#272A35] px-4 py-3">
          <span className="flex items-center gap-2 text-xs uppercase tracking-widest font-bold text-[#FF5A00]">
            <QrCode size={16} weight="bold" /> Scan Robot Pairing Code
          </span>
          <button data-testid="qr-close-btn" onClick={onClose} className="text-[#94A3B8] hover:text-[#FF3B30]">
            <X size={18} weight="bold" />
          </button>
        </div>
        <div className="relative p-4">
          <div id={regionId} className="overflow-hidden border border-[#272A35] bg-black min-h-[240px]" />
          {error ? (
            <p className="mt-3 text-xs text-[#FF3B30]">{error}</p>
          ) : (
            <p className="mt-3 text-[11px] text-[#475569] text-center">
              Point at the QR on your robot. It sets the BLE target then opens device pairing.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
